<style lang="less">
    .line-panel {
        position: relative;
        padding-top: 4px;
    }
    .line-setting {
        // margin-top: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow: visible;
    }
</style>
<style lang="stylus">
    .line-panel
        border-bottom-left-radius $right-view-radius
        border-bottom-right-radius $right-view-radius
        color $right-view-content-textcolor
</style>
<template>
    <div class="line-panel">
        <div class="line-setting">
            <LineSet :isDisabled="disabled" :from="fmtType.line" :fromPaintType="1" :index="0" @changeSet="$emit('changeSet')" />
        </div>
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    import LineSet from "./LineSet.vue";
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";

    @Component({
        components: {
            LineSet,
        },
    })
    export default class LinePanel extends Vue {
        color: string = "#000000";

        // changeLineType(v) {
        //     let view = window["_view"];
        //     this.$track("rightPanel", "line type", v);
        //     if (v !== this.lineType) {
        //         window["_view"]._tool.endEdit();
        //         if (v === "No line") {
        //             view.setFmt({}, eFmtSetFlag.ColorNone | this.fmtType.line);
        //         } else if (v === "Solid line") {
        //             view.setFmt({}, eFmtSetFlag.ColorSolid | this.fmtType.line);
        //         } else if (v === "Gradient line") {
        //             view.setFmt({}, eFmtSetFlag.ColorGradient | this.fmtType.line);
        //         }
        //     }
        // }

        get disabled() {
            const isDisabled = this.lineType === "No line" || this.isMMShape || !this.$store.state.shape.canLine;
            return isDisabled;
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        get masked() {
            return !this.$store.state.shape.canLine || this.isMMShape;
        }
        get lineType() {
            let type: number = this.type;
            if (type === null) {
                return "No line";
            }
            if (type === 0) {
                return "No line";
            } else if (type === 1) {
                return "Solid line";
            }
            //  else if (type > 1 && type < 5) {
            //     return "Gradient line";
            // }
        }
        set lineType(v: any) {}
        get type() {
            //是否disabled
            return this.$store.state.shape.lineFmt.type;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        // @Watch('type')
        // onTypeChanged(val: any) {
        //     if(val === null){
        //         this.masked = true;
        //     }else{
        //         this.masked = false;
        //     }
        // }

        mounted() {
            // if(this.type === null){
            //     this.masked = true;
            // }
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "LinePanel": {
      "noLine": "无线条",
      "solidLIne": "实线",
      "gradientLine": "渐变线"
    }
  },
  "en": {
    "LinePanel": {
      "noLine": "No line",
      "solidLIne": "Solid line",
      "gradientLine": "Gradient line"
    }
  },
  "fr": {
    "LinePanel": {
      "noLine": "Pas de ligne",
      "solidLIne": "Ligne solide",
      "gradientLine": "Ligne de dégradé"
    }
  },
  "de": {
    "LinePanel": {
      "noLine": "Keine Linie",
      "solidLIne": "Durchgezogene Linie",
      "gradientLine": "Verlaufslinie"
    }
  },
  "jp": {
    "LinePanel": {
      "noLine": "線なし",
      "solidLIne": "線（単色）",
      "gradientLine": "線（グラデーション）"
    }
  },
  "es": {
    "LinePanel": {
      "noLine": "No hay línea",
      "solidLIne": "Línea sólida",
      "gradientLine": "Línea de gradiente"
    }
  },
  "pt": {
    "LinePanel": {
      "noLine": "Sem Linha",
      "solidLIne": "Linha Sólida",
      "gradientLine": "Linha em Gradiente"
    }
  },
  "it": {
    "LinePanel": {
      "noLine": "Nessuna Linea",
      "solidLIne": "Linea Solida",
      "gradientLine": "Linea Gradiente"
    }
  },
  "tw": {
    "LinePanel": {
      "noLine": "無線條",
      "solidLIne": "實線",
      "gradientLine": "漸變線"
    }
  }
}
</i18n>
